import { Grado } from "../tipologiche/grado";
import { MotivoScadenza } from "../tipologiche/motivo-scadenza";
import { TipoAtto } from "../tipologiche/tipo-atto";
import { TipoEsito } from "../tipologiche/tipo-esito";
import { TipoFascicolo } from "../tipologiche/tipo-fascicolo";
import { TipoPratica } from "../tipologiche/tipo-pratica";
import { TipoRicorso } from "../tipologiche/tipo-ricorso.";
import { TipoScadenza } from "../tipologiche/tipo-scadenza";

export class CalcoloScadenze { 
    giorniAbbreviazione: number;
    dataSospensioneDa: number;
    dataSospensioneA: number;
    idData: string;
    attore: boolean;
    tipoAtto: TipoAtto;
    tipoEsito: TipoEsito;
    tipoScadenza: TipoScadenza;
    motivoScadenza: MotivoScadenza;
    tipoPratica: TipoPratica;
    tipoFascicolo: TipoFascicolo;
    grado: Grado;
    giornoPatrono: boolean;
    sospensioneFeriale: boolean;
    termineLibero: boolean;
    tipoRicorso: TipoRicorso;
}
